export const MediaIncludes = ['id', 'alt', 'url', 'translated', 'thumbnails'];
export const MinimalCategoryIncludes = ['id', 'name', 'translated', 'seoUrls', 'type'];
